// PRODOPSAI-385 drill-down: items with no parent Epic (or stale parent),
// most-recent-first. All rows are offenders by definition — the backend
// excludes anything Epic-linked. Columns come from the shared
// `buildIssueColumns` factory so this file stays a one-liner around the
// generic table.

import type { IUnlinkedItem, IUnlinkedItemsDrillResponse } from '@skystone/shared';
import { DrillTable } from './DrillTable';
import { buildIssueColumns } from './issue-columns';

const COLUMNS = buildIssueColumns<IUnlinkedItem>();

interface UnlinkedItemsTableProps {
  data: IUnlinkedItemsDrillResponse;
  loading: boolean;
  error: string | null;
  onPageChange: (page: number) => void;
}

export function UnlinkedItemsTable({ data, loading, error, onPageChange }: Readonly<UnlinkedItemsTableProps>) {
  return (
    <DrillTable
      columns={COLUMNS}
      rows={data.rows}
      rowKey={(row) => row.issueKey}
      pagination={data.pagination}
      onPageChange={onPageChange}
      loading={loading}
      error={error}
      emptyMessage="No unlinked items in the active filter range."
    />
  );
}
